import { useQuery } from 'urql'

import type { Project } from 'types'

import { HubProjectDetailDocument } from './hubProjects.graphql'

/**
 * Thin urql `useQuery` wrapper for the salesman detail page (#321 phase 2).
 *
 * Server-enforced scope: the SALESMAN row-level permission on `projects`
 * already limits the visible rows. This hook deliberately does NOT inject
 * any `salesman_id` predicate. See contracts/data-contracts.md C-15.
 *
 * Migrated off Refine `useOne` (master's wave-5 Refine removal) — the
 * SALESMAN field projection now lives in `HubProjectDetailDocument`.
 */
export const useHubProjectDetail = (id: number | string | undefined) => {
  const numericId =
    id === undefined || id === null || id === '' ? undefined : Number(id)
  const enabled = numericId !== undefined && !Number.isNaN(numericId)

  const [{ data, fetching, error }, reexecuteQuery] = useQuery({
    query: HubProjectDetailDocument,
    variables: { id: (numericId ?? 0) as number },
    pause: !enabled,
  })

  return {
    project: (data?.projects_by_pk ?? undefined) as Project | undefined,
    isLoading: fetching,
    isError: Boolean(error),
    refetch: () => reexecuteQuery({ requestPolicy: 'network-only' }),
  }
}
